import {
  createContactFromModel,
  deleteContact,
  updateContactFromModel,
  updateContactMutation,
} from '@akin-home/contacts/frontend';
import { userQueryKeys } from '@akin-home/users/react';
import { useMutation, useQueryClient } from 'react-query';
import { contactsQueryKeySet } from './query_key';

export const useCreateContactModel = () => {
  const client = useQueryClient();

  return useMutation(createContactFromModel, {
    onSuccess(data) {
      client.invalidateQueries(contactsQueryKeySet.lists());
      client.invalidateQueries(contactsQueryKeySet.all_pages());

      /** If the contact was created with a user, invalidate user queries */
      if (data.data.createContact?.user_id) {
        client.invalidateQueries(userQueryKeys.lists());
      }
    },
  });
};

export const useUpdateContactMutation = () => {
  const client = useQueryClient();

  return useMutation(updateContactMutation, {
    onSuccess(_, { input }) {
      client.invalidateQueries(contactsQueryKeySet.detail(input?.id));
      client.invalidateQueries(contactsQueryKeySet.lists());
      client.invalidateQueries(contactsQueryKeySet.all_pages());
    },
  });
};

export const useUpdateContactModel = () => {
  const client = useQueryClient();

  return useMutation(updateContactFromModel, {
    onSuccess(_, params) {
      client.invalidateQueries(contactsQueryKeySet.detail(params.contact.id));
      client.invalidateQueries(contactsQueryKeySet.lists());
      client.invalidateQueries(contactsQueryKeySet.all_pages());

      if (params.create_linked_user || params.delete_linked_user) {
        client.invalidateQueries(userQueryKeys.all);
      }
    },
  });
};

export const useDeleteContactModel = () => {
  const client = useQueryClient();

  return useMutation(
    (params: { id: string; user_id?: string }) =>
      deleteContact(params.id, params.user_id),
    {
      onSuccess(_, params) {
        client.removeQueries(contactsQueryKeySet.detail(params.id));
        client.invalidateQueries(contactsQueryKeySet.lists());
        client.invalidateQueries(contactsQueryKeySet.all_pages());

        if (params.user_id) {
          client.invalidateQueries(userQueryKeys.all);
        }
      },
    }
  );
};
